
// WhatsAppPendingBanner — Bannière de statut des messages en instance
import { useState, useEffect } from 'react';
import { useWhatsApp } from '../context/WhatsAppContext';

export default function WhatsAppPendingBanner() {
  var { workerOnline, pendingCount, flushNotification } = useWhatsApp();
  var [show, setShow] = useState(false);
  var [message, setMessage] = useState('');

  useEffect(function() {
    if (flushNotification) {
      setShow(true);
      setMessage(flushNotification.count + ' message(s) WhatsApp envoyé(s) avec succès !');
      var timer = setTimeout(function() { setShow(false); }, 5000);
      return function() { clearTimeout(timer); };
    }
  }, [flushNotification]);

  if (!show && pendingCount === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      padding: '10px 20px',
      borderRadius: '10px',
      fontSize: '0.85rem',
      fontWeight: 500,
      textAlign: 'center',
      maxWidth: '360px',
      width: '90%',
      transition: 'all 0.3s ease',
      animation: 'fadeUp 0.3s ease-out',
      ...(flushNotification ? {
        background: 'linear-gradient(135deg, #059669, #047857)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(5, 150, 105, 0.4)',
      } : {
        background: 'linear-gradient(135deg, #d97706, #ea580c)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(234, 88, 12, 0.4)',
      })
    }}>
      {flushNotification ? (
        <span>✅ {message}</span>
      ) : (
        <span>
          <span style={{ marginRight: 8 }}>⏳</span>
          {pendingCount} message(s) en attente — envoi automatique à la reconnexion WhatsApp
        </span>
      )}
    </div>
  );
}
